import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http.service';
import { Config } from '../../shared/services/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  constructor(private http: HttpService) { }

  getUser(uuid: string) {
    return <Observable<any>>this.http.get(Config.urls.appUsers + 'getUser/' + uuid);
  }

  getByGuid(uuid: string) {
    return <Observable<any>>this.http.get(Config.urls.users + 'getByGuid/' + uuid);
  }

  getUsers(projectId: number) {
    return <Observable<any>>this.http.get(Config.urls.appUsers + 'getUsers/' + projectId);
  }

  getByClassGuid(uuid: string) {
    return this.http.get(Config.urls.users + 'getByClassGuid/' + uuid);
  }

  getReceivers(certificateTypeId: number) {
    return <Observable<any>>this.http.get(Config.urls.appUsers + 'getReceivers/' + certificateTypeId);
  }

  save(model: any) {
    return this.http.post(Config.urls.appUsers + 'save', model);
  }

  changePassword(model: any) {
    return this.http.post(Config.urls.users + 'changePassword', model);
  }

  changeUserPassword(uuid: string, model: any) {
    return this.http.post(`${Config.urls.users}changeUserPassword/${uuid}`, model);
  }

  getMappedSubjects(uuid: string, mappedOnly: number = 0) {
    return this.http.getAll(`${Config.urls.base}DB/Query/GetMappedSubjects?UserGuid=${uuid}&MappedOnly=${mappedOnly}`);
  }

  getMappedSubjectsByClassGuid(uuid: string, mappedOnly: number = 0) {
    return this.http.getAll(`${Config.urls.base}DB/Query/GetMappedSubjects?ClassGuid=${uuid}&MappedOnly=${mappedOnly}`);
  }

  getMyProfile() {
    return <Observable<any>>this.http.get(Config.urls.users + 'myProfile/');
  }

  getProfile(id: number) {
    return <Observable<any>>this.http.get(Config.urls.users + 'getProfile/' + id);
  }

  saveMappedSubjects(map: any[]): any {
    return this.http.post(`${Config.urls.users}SaveMappedSubjects`, map);
  }

  saveMappedSubjectsForClass(map: any[]): any {
    return this.http.post(`${Config.urls.users}SaveMappedSubjectsForClass`, map);
  }

  sendFeedback(model: any) {
    return <Observable<any>>this.http.post(Config.urls.users + 'feedback', model);
  }

  updateProfile(model: any) {
    return <Observable<any>>this.http.post(Config.urls.users + 'updateProfile', model);
  }

  updateSettings(model: any) {
    return <Observable<any>>this.http.post(Config.urls.users + 'updateSettings', model);
  }

  uploadPhoto(model: FormData) {
    return this.http.post(Config.getUrl('api/upload/userPhoto'), model);
  }
}
